import api from "../api"; // Giả định em có một module axios tên là api

// Tạo thông báo
async function createNotification(notificationData) {
  try {
    const response = await api.post("/api/thong-bao", notificationData);
    console.log("Thông báo đã được yêu cầu tạo thành công:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Lỗi khi tạo thông báo:",
      error.response?.data || error.message
    );
    // Ném lỗi ra để component có thể xử lý (ví dụ: hiển thị popup lỗi)
    throw error;
  }
}

// Lấy danh sách thông báo
async function getNotifications({ page = 1, size = 10, status = "all" } = {}) {
  try {
    // UI 1-based -> API 0-based
    const resp = await api.get("/api/thong-bao", {
      params: { page: Math.max(0, page - 1), size, status },
    });
    return resp.data; // { content, number, size, totalElements, totalPages, ... }
  } catch (error) {
    console.error("Lỗi khi tải thông báo:", error);
    // Trả khung Page rỗng để FE không crash
    return {
      content: [],
      number: 0,
      size,
      totalElements: 0,
      totalPages: 1,
      first: true,
      last: true,
    };
  }
}

// Đánh dấu 1 thông báo đã đọc
async function markAsRead(notificationId) {
  try {
    await api.put(`/api/thong-bao/${notificationId}/doc`);
    return true;
  } catch (error) {
    console.error(
      `Lỗi khi đánh dấu đã đọc cho thông báo ${notificationId}:`,
      error
    );
    return false;
  }
}

// Đánh dấu tất cả đã đọc
async function markAllAsRead() {
  try {
    await api.put("/api/thong-bao/doc-tat-ca");
    return true;
  } catch (error) {
    console.error("Lỗi khi đánh dấu đọc tất cả:", error);
    return false;
  }
}

export const notificationService = {
  getNotifications,
  markAsRead,
  markAllAsRead,
  createNotification,
};
